import { render } from "./SalesImpactReport.vue?vue&type=template&id=508553d7&scoped=true"
import script from "./SalesImpactReport.vue?vue&type=script&lang=js"
export * from "./SalesImpactReport.vue?vue&type=script&lang=js"

import "./SalesImpactReport.vue?vue&type=style&index=0&id=508553d7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508553d7"]])

export default __exports__